export default __webpack_public_path__ + "static/StyreneA-Regular-Web-687695370ac0473d7999e94a0c49ca3c.woff2";